import { render, staticRenderFns } from "./MyCompetitors.vue?vue&type=template&id=a757bc98&"
import script from "./MyCompetitors.vue?vue&type=script&lang=js&"
export * from "./MyCompetitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports